import { useEffect } from 'react';

export default function useOnMount(callback) {
  useEffect(callback, []);
}
